
    import debounce from 'lodash/debounce';

    export default {
        name: 'DotIndicator',

        props: {
            total: {
                type: Number,
                default: 0,
                required: true,
            },

            current: {
                type: Number,
                default: 1,
                required: true,
            },
        },

        watch: {
            current(v) {
                this.scrollToCenter(v);
            },
        },

        mounted() {
            this.init();
        },

        methods: {
            init() {
                const itemWidth = this.$refs.dotIndicatorItem[0].offsetWidth;
                const totalWidth = this.total > 5 ? itemWidth * 5 : this.total * itemWidth;
                this.$refs.dotIndicator.style.width = `${totalWidth}px`;
            },

            scrollToCenter: debounce(function(current) {
                const itemWidth = this.$refs.dotIndicatorItem[0].offsetWidth;
                const start = 3;
                const pos = itemWidth * (current - start);
                const translateX = `-${pos}px`;

                if (!this.isLastSet(current)) {
                    this.$velocity(this.$refs.track, { translateX }, { easing: 'easeInOutQuart', duration: 600 });
                }
            }, 200),

            isLastSet(current) {
                return current + 1 >= this.total;
            },
        },
    };
